import { api } from '@/common/api';

const store = {
    namespaced: true,
    state() {
        return {
            notifications: [
                {
                    type: null,
                    notifyInstance: null,
                    lead: null,
                    deal: null,
                    contact: {
                        id: null,
                        email: null,
                        name: null,
                        address: null,
                        birthday: null,
                        comment: null,
                        company_id: null,
                        contact_phones: [
                            {
                                id: null,
                                contact_id: null,
                                phone: null,
                                is_main: null
                            }
                        ]
                    },
                    queue: {
                        id: null,
                        src_num: null,
                        call_id: null,
                        created_at: null,
                        dst_num: null,
                        entity_id: null,
                        entity_type: null,
                        event: null,
                        lead: null,
                        short_dst_num: null,
                        short_src_num: null,
                        timestamp: null,
                        updated_at: null
                    }
                }
            ]
        };
    },
    mutations: {
        setNotifications(state, notifications) {
            state.notifications = notifications;
        },
        clearAll(state) {
            state.notifications = null;
        }
    },
    actions: {
        callToPhone(context, data) {
            return new Promise((resolve, reject) => {
                api.get('/voip/call/' + data.phone).then(
                    response => {
                        resolve(response);
                    },
                    error => {
                        reject(error);
                    });
            });
        }
    },
    getters: {}
};

export default store;
